/*
 *  Copyright (c) Qwoach LLC 2023. All rights reserved.
 *  Unauthorized copying of this file, via any medium is strictly prohibited
 *  Proprietary and confidential
 *  Created by Artem Bogush <artem@qwoach.com> on 14/3/2023
 */

import {uuidv4} from "@/utils/helpers";
import {syncKey} from "@shared/Filterable/PropertyDecorators";
import ShareableItem from "@shared/ShareableFilterableItem.js";

export default class DecoratedItem extends ShareableItem {

	static syncableProps = []

	constructor(options) {
		super(options);
		this.createClassId()
	}

	// () {
	// 	let thisClassName = this._filterableItemClassId//this.constructor.name
	// 	// console.log("setupFilterableKeysIfNeeded: this.constructor.name = ", this.constructor.name, ", this.constructor = ", this.constructor, ", this = ", this)
	// 	let keys = FilterableItem.filterableKeysMap[thisClassName]
	//
	// 	// console.log("setupFilterableKeysIfNeeded: keys = ", keys)
	// 	if (!keys){
	// 		keys = []
	// 		keys = this.getAllFilterableKeys()
	// 		let thisClassName = this.getClassName()
	// 		FilterableItem.filterableKeysMap[thisClassName] = keys
	// 	}
	// 	// console.log("buildSearchKeywords: keys = ", keys, ", thisClassName = ", thisClassName, ", this = ", this)
	// 	// console.log("setupFilterableKeysIfNeeded: FilterableItem.filterableKeysMap = ", FilterableItem.filterableKeysMap)
	//
	// 	return keys
	// }

	createClassId(){
		if(!this.constructor.prototype._itemClassId){
			this.constructor.prototype._itemClassId = uuidv4()
		}
		// console.log("createClassId: this.constructor.prototype._itemClassId = ", this.constructor.prototype._itemClassId, ", this = ", this)
	}

	getClassName(){
		return this._itemClassId
	}


	syncSyncableProps(){
		// console.log("syncSyncableProps: ", this)
		let propsMap = this.getAllSyncableProps()
		Object.keys(propsMap).forEach(prop => {
			let options = propsMap[prop]
			// console.log("syncSyncableProps: prop = ", prop, ", options = ", options)
			if(this[options.targetProp]){
				this[prop] = options.transform(this[options.targetProp])
			}
		})
	}



	getAllSyncableProps(){
		let className = this.getClassName()
		if(!DecoratedItem.syncableProps[className]){
			let props = {}
			Object.keys(this).forEach(key => {
				let options = this.getSyncableOptions(key)
				if(options){ props[key] = options }
			})
			DecoratedItem.syncableProps[className] = props
		}
		return DecoratedItem.syncableProps[className]
	}


	getSyncableOptions(propertyKey){
		let options = Reflect.getMetadata(syncKey, this, propertyKey);
		// console.log("buildSearchKeywords isFilterable: ", options, ", propertyKey = ", propertyKey)
		if(!!options && options.isSyncable){
			return options
		}
	}

}
